import { InputHTMLAttributes } from 'react';
import { Search } from 'lucide-react';
import { cn } from '../../lib/cn';

export type SearchFieldProps = InputHTMLAttributes<HTMLInputElement>;

/** The pill-shaped search input used in the topbar and every filter bar. */
export function SearchField({ className, ...props }: SearchFieldProps) {
  return (
    <div className={cn('flex items-center gap-2 rounded-full bg-surface-sunken px-3 py-2', className)}>
      <Search size={16} className="shrink-0 text-text-tertiary" />
      <input
        {...props}
        className="w-full min-w-0 bg-transparent text-sm text-text-primary placeholder:text-text-tertiary focus:outline-none"
      />
    </div>
  );
}
